import { getJobSyncCellRenderersHook } from "./cellRenderersHooks";
import { getJobSyncIntegrationDataHook } from "./integrationDataHooks";
import { getJobSyncRowClickHook } from "./rowClickHooks";
import { getJobSyncTableDataHook } from "./tableDataHooks";

import { registerSchemaHooks } from "@/features/integrations/shared/renderer/hooks/schemaRegistry";

/**
 * Register job-sync module hooks with the central module registry.
 * This file is imported at module initialization to register hooks.
 */
registerSchemaHooks("job-sync", {
  getTableDataHook: getJobSyncTableDataHook,
  getIntegrationDataHook: getJobSyncIntegrationDataHook,
  getCellRenderersHook: getJobSyncCellRenderersHook,
  getRowClickHook: getJobSyncRowClickHook,
});
